import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type ToastVariant = 'error' | 'success' | 'warning'

export interface ToastState {
	message: string
	variant: ToastVariant
	isOpened: boolean
}

const initialState: ToastState = {
	message: '',
	variant: 'error',
	isOpened: false,
}

export const toastSlice = createSlice({
	name: 'toast',
	initialState,
	reducers: {
		show: (state, action: PayloadAction<{ message: string; variant: ToastVariant }>) => {
			state.message = action.payload.message
			state.variant = action.payload.variant
			state.isOpened = true
		},
		hide: (state) => {
			state.isOpened = false
		},
		setOpened: (state, action: PayloadAction<boolean>) => {
			state.isOpened = action.payload
		},
		setMessage: (state, action: PayloadAction<string>) => {
			state.message = action.payload
		},
		setVariant: (state, action: PayloadAction<ToastVariant>) => {
			state.variant = action.payload
		},
	},
})

export const { show, hide, setOpened, setMessage, setVariant } = toastSlice.actions

export default toastSlice.reducer
